import React, { forwardRef, ForwardRefExoticComponent, RefAttributes } from 'react';
import cns from 'classnames';
import styles from './InputNumber.module.scss';

export interface IInputNumberProps extends RefAttributes<HTMLInputElement> {
  className?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  value?: string | number;
  disabled?: boolean;
}

const CustomInputNumber: ForwardRefExoticComponent<IInputNumberProps> = forwardRef(
    ({ className, onChange, value, disabled, ...rest }, ref) => (
      <input
        type="number"
        ref={ref}
        className={cns(styles.inputNumber, className)}
        onChange={onChange}
        value={value}
        disabled={disabled}
        {...rest}
      />
    )
  );

export default CustomInputNumber;
